'use strict';

import {
    addObjectToLocalStorage,
    createElements,
    findSelectionAndCrmData,
    flatClick,
    numberWithCommas,
    rotation_to_flat,
} from '../../functions';
import { changeLangToCurrent, getCurrentLang } from '../language/langSwitcher';
import { Buildings, cardsData, isMobile, settingsData } from '../../settings';
import {dataArrayOfFlat} from "../cards/cardsConfig";
import {threeJsVariables} from "../../settings";
import {hoverOutPreviousSelection, selectionBoxesSetStatusColor} from "../threejs/raycast";
import {UnitCardClass} from "../cards/unitCards/UnitCardClass";
import {changeActiveCardWhenBuildingClick} from "../search/search";
import { CardTypes, ViewMode } from '../../common';
import {openOptionsCard} from "../cards/optionsCards";
import {getPropType} from "../cards/unitCards/unitCardFunctions";

let tooltip = null;
export const createTooltip = () => {
    tooltip = createElements('div', ['flat-tooltip'], document.body);

    // HEADER
    const tooltipHeader = createElements('div', ['flat-tooltip__header', 'card__header'], tooltip);
    const tooltipTitleBox = createElements('div', ['flat-tooltip__title-box', 'card__title-box'], tooltipHeader);
    const tooltipSubtitle = createElements('div', ['flat-tooltip__subtitle-box', 'card__subtitle-box'], tooltipHeader);

    const tooltipTitle = createElements('h3', ['flat-tooltip__title', 'card__title'], tooltipTitleBox);
    const tooltipPrice = createElements('div', ['flat-tooltip__price', 'card__price'], tooltipTitleBox);

    const tooltipFlatName = createElements('span', ['flat-tooltip__flat-name', 'card__title-flat-name', 'language-string'], tooltipTitle, 'beforeend', {
        data: 'data-dictionary',
        value: 'Apt.'
    });
    const tooltipFlatNumber = createElements('span', ['flat-tooltip__flat-number', 'card__title-flat-number', 'language-string'], tooltipTitle);

    let tooltipTowerName = null;
    if (Buildings.getBuildingsInfoLength() > 1)
        tooltipTowerName = createElements('div', ['flat-tooltip__tower-name', 'card__tower-name'], tooltipSubtitle);
    const tooltipFloorNum = createElements('div', ['flat-tooltip__floor-number', 'card__floor-number'], tooltipSubtitle);
    const tooltipFloor = createElements('span', ['flat-tooltip__floor-number-floor', 'card__floor_floor', 'language-string'], tooltipFloorNum, 'beforeend', {
        data: 'data-dictionary',
        value: 'floor'
    });
    const tooltipNum = createElements('span', ['flat-tooltip__floor-number_num', 'card__floor_num'], tooltipFloorNum);


    tooltipFloor.innerHTML = changeLangToCurrent('floor');
    const priceValue = createElements('span', [`flat-tooltip__price-value`, 'card__price-value'], tooltipPrice);
    const priceCurrency = createElements('span', [`flat-tooltip__price-currency`, 'card__price-currency', 'language-string'], tooltipPrice);

    // INFO-POINTS

    const tooltipInfoPoints = createElements('div', ['flat-tooltip__info-points', 'card__info-points'], tooltip);

    const flatNumber = createElements('div', ['flat-tooltip__flat-number'], tooltip);
    const flatModel = createElements('div', ['flat-tooltip__flat-model'], tooltip);

    tooltip.addEventListener('click', clickTooltipHandle);

};

export const updateTooltipText = async (selectedObject, crmDataObject) => {

    const isAmenity = selectedObject.userData.customSelection;

    if (!crmDataObject && isAmenity) {
        crmDataObject = selectedObject.userData.crm_data;
    }

    isAmenity ? tooltip.classList.add('amenity') : tooltip.classList.remove('amenity');

    // createPreview(selectedObject, crmDataObject);

    if (!isAmenity) {
        tooltip.setAttribute('data-engineid', crmDataObject?.engineId);
    }

    updateTooltipHeader(crmDataObject);
    updateTooltipInfoPoints(crmDataObject);
}

const clickTooltipHandle = () => {
    if (tooltip.style.display === 'none') {
        return
    }

    const {activeTower, selectedMesh} = findSelectionAndCrmData(tooltip.getAttribute('data-engineId'))
    cardsData.cardMode.isAmenities = Boolean(settingsData.lastHoverObject.userData.customSelection);
    const isClickedFlat = activeTower.apartments.find(flat => flat.userData.isClicked);
    if (isClickedFlat) {
        const unitCard = UnitCardClass.findCard()?.html;
        hoverOutPreviousSelection(unitCard);
    }

    selectionBoxesSetStatusColor(selectedMesh, 'click');
    settingsData.currentFloor = !cardsData.cardMode.isAmenities ? selectedMesh.userData.floor : 0;
    rotation_to_flat(selectedMesh);

    tooltip.style.display = 'none' 

    if (cardsData.cardMode.isAmenities) {
        if (UnitCardClass.findCard().html) UnitCardClass.closeMultipleCards();
        openOptionsCard();
    } else {
        flatClick(selectedMesh);
        if (document.querySelector('.search__result-list')) {
            changeActiveCardWhenBuildingClick(selectedMesh);
        }
    }

}

const updateTooltipHeader = (crmDataObject) => {
    // const towerName = buildings_info.find(option => option.isActive).towerName;
    const towerName = Buildings.getActiveBuilding().info.towerName;

    let name;

    if (Array.isArray(towerName)){
        name = towerName.find(el => el.lang === getCurrentLang()).value;
    } else {
        name = towerName;
    }

    const tooltipTowerName = document.querySelector('.flat-tooltip__tower-name');
    const tooltipFlatName = document.querySelector('.flat-tooltip__flat-name');
    const tooltipFlatNumber = document.querySelector('.flat-tooltip__flat-number');
    const tooltipFloorNum = document.querySelector('.flat-tooltip__floor-number_num');
    const priceCurrency = document.querySelector('.flat-tooltip__price-currency');
    const priceValue = document.querySelector(`.flat-tooltip__price-value`);

    tooltipFlatName.innerHTML = changeLangToCurrent(getPropType(crmDataObject.propType));

    if (tooltip.classList.contains('amenity')) {
        tooltipFlatNumber.classList.add('language-string');
        tooltipFlatNumber.setAttribute('data-dictionary', crmDataObject.propNum);
        tooltipFlatNumber.innerHTML = changeLangToCurrent(crmDataObject.propNum);
    } else {
        tooltipFlatNumber.classList.remove('language-string');
        tooltipFlatNumber.removeAttribute('data-dictionary');
        tooltipFlatNumber.innerHTML = crmDataObject.propNum;
    }

    tooltipFloorNum.innerHTML = crmDataObject.floorNum;

    const regExp = /[a-z\u0590-\u05fe]/gi;

    const isStringName = regExp.test(name);
    if (Buildings.getBuildingsInfoLength() > 1) {
        if (!isStringName) {
            let towerNumber =  document.querySelector('.flat-tooltip__tower-name_num');
            let towerTitle = document.querySelector('.flat-tooltip__tower-name_title');

            if (!towerNumber) {
                towerNumber = createElements('span', [`flat-tooltip__tower-name_num`, 'language-string'], tooltipTowerName, 'beforeend', {
                    data: 'data-dictionary',
                    value: 'building'
                });
                towerTitle = createElements('span', [`flat-tooltip__tower-name_title`], tooltipTowerName);
            }

            towerTitle.innerHTML = name;
            towerNumber.innerHTML = changeLangToCurrent('building')  + ' ';
        } else {
            tooltipTowerName.innerHTML = name;
        }
    }

    if (crmDataObject.status !== "Available") {
        priceCurrency.setAttribute('data-dictionary', crmDataObject.status);
        priceCurrency.classList.add('language-string');
        priceCurrency.innerHTML = changeLangToCurrent(crmDataObject.status);
        priceValue.innerHTML = '';

        return;
    }

    let showPrice = config.property.settings.displayPrice === 'show' || settingsData.isConferenceHost;

    if (!showPrice || +crmDataObject.salePrice === 0) {
        priceCurrency.innerHTML = '';
        priceValue.innerHTML = '';
        return;
    }

    const currencyLocal = config.localization.currencyLabel;
    priceCurrency.setAttribute('data-dictionary', currencyLocal);
    priceCurrency.innerHTML = changeLangToCurrent(currencyLocal);
    priceValue.innerHTML = numberWithCommas(Math.floor(crmDataObject.salePrice));
}

const updateTooltipInfoPoints = (crmDataObject) => {

    let tooltipInfoPoint = document.querySelector('.flat-tooltip__info-points');

    tooltipInfoPoint.innerHTML = '';

    const regExp = /([A-Za-z])\w+/g;
    // const measurement = 'm2';
    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';
    const measurement = config.localization.area ? config.localization.area : "m2";
    const showPrice = config.property.settings.displayPrice === 'show';

    const cardsInfo = dataArrayOfFlat(crmDataObject);

    const infoPointsData = cardsInfo.filter((data, index) => {
        if ( config.features.apartments.aptCardFieldsCntUnit.indexOf(data.name) !== -1) {
            return data;
        }
    })

    infoPointsData.forEach((data, index) => {
        if (+data.data === 0) return;

        const cardContentBlock = createElements('div', [`flat-tooltip-card__info-points-block`, 'card__info-points-block'], tooltipInfoPoint);
        const cardContentWrapper = createElements('div', [`flat-tooltip-card__info-points-wrapper`, 'card__info-points-block-wrapper'], cardContentBlock);
        const cardModelName = createElements('div', [`flat-tooltip-card__info-points-block_data`, 'card__info-points-block_data'], cardContentWrapper);
        const cardModelNameText = createElements('span', [`flat-tooltip-card__info-points-block_data_text`, 'card__info-points-block_data_text', 'language-string'], cardModelName, 'beforeend', {
            data: 'data-dictionary',
            value: data.data,
        });
        const contentSubtext = createElements('div', [`flat-tooltip-card__info-points-block_subtitle`, 'card__info-points-block_subtitle'], cardContentWrapper);

        if (regExp.test(data.data)) {
            cardModelNameText.style.direction = "ltr";
        }

        contentSubtext.innerHTML += `<span class="language-string" data-dictionary="${data.name}">${changeLangToCurrent(data.name)}</span>`;
        if (data.name === 'area') {
            const coma = `<span>,</span>`;
            contentSubtext.innerHTML += coma;
            const measurementTag = createElements('span', ['language-string', 'card__info-points-block_subtitle-measurement'], contentSubtext, 'beforeend', {
                'data': 'data-dictionary',
                'value': measurement
            });
            measurementTag.innerHTML += changeLangToCurrent(measurement);
            measurementTag.classList.add('meters');
        }

        cardModelNameText.innerHTML = changeLangToCurrent(data.data);
        cardModelName.classList.add(data.icon);
    });
};

export const updateTooltipPosition = (top, left, hoveredObject) => {
    if (hoveredObject) {
        showTooltip();
    }

    return hoveredObject;
};

export const hideTooltip = () => {
    if (isMobile) return;

    if (tooltip){
        tooltip.style.transition = '';
        tooltip.style.display = 'none';
        tooltip.style.opacity = 0;
    }
};

export const showTooltip = () => {
    if (settingsData.buildingDestroyed || settingsData.isDesktopMode) return;

    tooltip.style.display = 'block';
    tooltip.style.opacity = 0;
    setTimeout(()=>{
        if (settingsData.activeViewMode !== ViewMode.Cylinder){
            return;
        }

        const width = tooltip.getBoundingClientRect().width;
        const height = tooltip.getBoundingClientRect().height;
        let dir = document.documentElement.getAttribute('dir');
    
        tooltip.style.top = threeJsVariables.mouse.winY + height > window.innerHeight ? window.innerHeight - height - 10 + 'px' : threeJsVariables.mouse.winY + 'px';
        tooltip.style.left = (dir === 'rtl') ? (threeJsVariables.mouse.winX - 10 + 'px') : (threeJsVariables.mouse.winX - width - 10 + 'px');

        tooltip.style.transition = 'opacity 500ms';
        tooltip.style.opacity = 1;
    },500);

};